module.exports = __webpack_public_path__ + "static/img/feature_3.f79a9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/feature_3.png
// module id = /hUq
// module chunks = 0